import React, { useState, useEffect } from "react";
//import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import { useFormik } from "formik";

import * as Yup from "yup";
import IconButton from "@mui/material/IconButton";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import FormHelperText from "@mui/material/FormHelperText";

import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";

import Modal from "../components/Modal";
import api from "../service/api";
import { setError } from "../reducers/appSlice";

var validationSchema = Yup.object().shape({
  provincia: Yup.number().required("Requerido"),
  departamento: Yup.number().required("Requerido"),
  localidad: Yup.number().required("Requerido"),
  domicilio: Yup.string().required("Requerido"),
});

const ModalDomicilio = (props) => {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [provincias, setProvincias] = useState([]);
  const [departamentos, setDepartamentos] = useState([]);
  const [localidades, setLocalidades] = useState([]);

  const handleOpen = () => {
    if (provincias.length === 0) buscarProvincias();
    setOpen(true);
  };

  const handleClose = () => {
    formik.handleReset();
    setOpen(false);
  };

  const formik = useFormik({
    initialValues: {
      provincia: "",
      departamento: "",
      localidad: "",
      domicilio: "",
    },
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: (values) => {
      let domicilioCompleto = ""
      let txtProvincia = "";
      let txtDepartamento = "";
      let txtLocalidad = "";

      localidades.map((localidad) => {
        if (localidad.id === values.localidad) txtLocalidad = localidad.nombre;
      });

      departamentos.map((departamento) => {
        if (departamento.id === values.departamento) txtDepartamento = departamento.nombre;
      });

      provincias.map((provincia) => {
        if (provincia.id === values.provincia) txtProvincia = provincia.nombre;
      });

      if (txtLocalidad !== txtDepartamento)
        domicilioCompleto = values.domicilio + " . " + txtLocalidad + " - " + txtDepartamento + " - " + txtProvincia;
      else
        domicilioCompleto = values.domicilio + " . " + txtLocalidad + " - " + txtProvincia;

      props.resultado({
        localidadId: values.localidad,
        domicilio: values.domicilio,
        personaId: props.persona.personaId,
        domicilioCompleto: domicilioCompleto
      });

      handleClose();
    },
    onReset: () => {
      //
    },
  });

  const buscarProvincias = () => {
    api
      .buscarProvincias({})
      .then((res) => {
        setProvincias(res.data);
      })
      .catch((e) => {
        dispatch(setError("Error al obtener las provincias"));
      });
  };

  const buscarDepartamentos = (provinciaId) => {
    api
      .buscarDepartamentos({ provincia: provinciaId })
      .then((res) => {
        setDepartamentos(res.data);
      })
      .catch((e) => {
        dispatch(setError("Error al obtener los departamentos"));
      });
  };

  const buscarLocalidades = (departamentoId) => {
    api
      .buscarLocalidades({ departamento: departamentoId })
      .then((res) => {
        setLocalidades(res.data);
      })
      .catch((e) => {
        dispatch(setError("Error al obtener las localidades"));
      });
  };

  useEffect(() => {
    if (formik.values.provincia !== "")
      buscarDepartamentos(formik.values.provincia);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formik.values.provincia]);

  useEffect(() => {
    if (formik.values.departamento !== "")
      buscarLocalidades(formik.values.departamento);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formik.values.departamento]);

  return (
    <>
      <IconButton title="Agregar domicilio" size="small" onClick={handleOpen}>
        <LocationOnOutlinedIcon fontSize="small" />
      </IconButton>

      <Modal open={open} handleClose={handleClose} size="sm">
        <Typography variant="cuerpo" paragraph>
          {props?.persona?.nombre}
        </Typography>
        <form
          id="formDomicilio"
          name="formDomicilio"
          onSubmit={formik.handleSubmit}
          onReset={formik.handleReset}
          noValidate
          autoComplete="off"
        >
          <Grid container spacing={1}>
            <Grid item lg={4} xs={12}>
              <FormControl
                variant="outlined"
                size="small"
                fullWidth
                error={
                  formik.touched.provincia && Boolean(formik.errors.provincia)
                }
              >
                <InputLabel id="provinciaLabel">Provincia</InputLabel>
                <Select
                  labelId="provinciaLabel"
                  label="Provincia"
                  id="provincia"
                  name="provincia"
                  variant="outlined"
                  fullWidth
                  value={formik.values.provincia}
                  onChange={formik.handleChange}
                >
                  <MenuItem value="">Seleccione</MenuItem>
                  {provincias.map((provincia) => (
                    <MenuItem value={provincia.id} key={provincia.id}>
                      {provincia.nombre}
                    </MenuItem>
                  ))}
                </Select>
                <FormHelperText>
                  {formik.touched.provincia && formik.errors.provincia}
                </FormHelperText>
              </FormControl>
            </Grid>
            <Grid item lg={4} xs={12}>
              <FormControl
                variant="outlined"
                size="small"
                fullWidth
                error={
                  formik.touched.departamento &&
                  Boolean(formik.errors.departamento)
                }
                disabled={formik.values.provincia === ""}
              >
                <InputLabel id="departamentoLabel">Departamento</InputLabel>
                <Select
                  labelId="departamentoLabel"
                  label="Departamento"
                  id="departamento"
                  name="departamento"
                  variant="outlined"
                  fullWidth
                  value={formik.values.departamento}
                  onChange={formik.handleChange}
                >
                  <MenuItem value="">Seleccione</MenuItem>
                  {departamentos.map((departamento) => (
                    <MenuItem value={departamento.id} key={departamento.id}>
                      {departamento.nombre}
                    </MenuItem>
                  ))}
                </Select>
                <FormHelperText>
                  {formik.touched.departamento && formik.errors.departamento}
                </FormHelperText>
              </FormControl>
            </Grid>
            <Grid item lg={4} xs={12}>
              <FormControl
                variant="outlined"
                size="small"
                fullWidth
                error={
                  formik.touched.localidad && Boolean(formik.errors.localidad)
                }
                disabled={formik.values.departamento === ""}
              >
                <InputLabel id="localidadLabel">Localidad</InputLabel>
                <Select
                  labelId="localidadLabel"
                  label="Localidad"
                  id="localidad"
                  name="localidad"
                  variant="outlined"
                  fullWidth
                  value={formik.values.localidad}
                  onChange={formik.handleChange}
                >
                  <MenuItem value="">Seleccione</MenuItem>
                  {localidades.map((localidad) => (
                    <MenuItem value={localidad.id} key={localidad.id}>
                      {localidad.nombre}
                    </MenuItem>
                  ))}
                </Select>
                <FormHelperText>
                  {formik.touched.localidad && formik.errors.localidad}
                </FormHelperText>
              </FormControl>
            </Grid>
          </Grid>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
            }}
          >
            <TextField
              id="domicilio"
              name="domicilio"
              label="Domicilio"
              variant="outlined"
              size="small"
              margin="dense"
              fullWidth
              value={formik.values.domicilio}
              onChange={formik.handleChange}
              error={
                formik.touched.domicilio && Boolean(formik.errors.domicilio)
              }
              helperText={formik.touched.domicilio && formik.errors.domicilio}
            />
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row-reverse",
            }}
          >
            <Button sx={{ m: 1 }} variant="verde" type="submit">
              {"Agregar"}
            </Button>
            <Button sx={{ m: 1 }} variant="plata" onClick={handleClose}>
              {"Cancelar"}
            </Button>
          </Box>
        </form>
      </Modal>
    </>
  );
};

export default ModalDomicilio;
